export default __webpack_public_path__ + "static/media/ie.93368369.svg";